import React from "react";

/** Sidebar / settings brand text — last word in gold (matches .sb-brand). */
export function OrgBrandName({ name, className = "sb-brand", compact = false }) {
  const label = (name || "Founders Bridge").trim() || "Founders Bridge";
  const words = label.split(/\s+/);
  const cls = compact ? `${className} sb-brand--compact` : className;

  if (words.length <= 1) {
    return <div className={cls}>{label}</div>;
  }
  const last = words.pop();
  return (
    <div className={cls}>
      {words.join(" ")}
      <br />
      <span>{last}</span>
    </div>
  );
}

export function OrgLogoMark({ logoUrl, name, className = "sb-logo-img", onError }) {
  if (logoUrl) {
    return <img src={logoUrl} alt={name || "Organisation logo"} className={className} onError={onError} />;
  }
  return <OrgBrandName name={name} className="sb-brand" />;
}
